export default __webpack_public_path__ + "static/media/profile-pic (1).a076cebd.png";